import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { ActiveUser, BfxBlotterAction, BfxBlotterContextMenuItem } from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
import { BfxBaseBlotter } from "app/bfx-base-blotter/bfx-base-blotter";
import { BmarkFwdRiskDataService } from "app/bfx-bmark-summary/blotters/spot-risk/services/bmark-fwd-risk-data.service";
import { EXPORT_INPUT_TYPE, EXPORT_OUTPUT_TYPE } from "app/bfx-dialogs/bfx-dialog-export.component";
import { BfxDialogCommand } from "app/bfx-dialogs/models/bfx-dialog-command.enum";
import { BfxDialogData } from "app/bfx-dialogs/models/bfx-dialog-data.model";
import { Subject } from "rxjs";
import { BmarkFwdRiskDisplayModel } from "shared/cubiq-services/model/benchmarks/BmarkSpotRiskDisplay.model";
import {
  BfxBaseBlotterContextMenuService,
  BfxBlotterActionEvent,
  BfxBlotterActionSubject,
} from "../../../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { TenorAdapter } from "shared/cubiq-services/adapter/orderBlotter/TenorAdapter";
const logger = LoggerService.for(__dirname);

/**
 * Context menu service for BM Forward risk - currently only provides a single Export menu item
 * that exports all rows in display order
 */
@Injectable()
export class BmarkFwdRiskContextMenuService extends BfxBaseBlotterContextMenuService<any> {
  public menuItems: Array<BmarkFwdRiskContextMenuItem>;

  private fwdRiskDialogSubject = new Subject<BfxDialogData>();
  public dialogCtrl$ = this.fwdRiskDialogSubject.asObservable();

  constructor() {
    super(new BfxBlotterActionSubject());
    this.initialize();
  }

  private initialize() {
    this.initMenuItems();
    this.actionSubject.subscribe((event) => {
      switch (event.action) {
        case BfxBlotterAction.ACTION_SPOT_RISK_EXPORT_TO_CSV: {
          this.exportToCSV(event);
          break;
        }
      }
    });
  }

  protected override getEnabledActions(
    _items: any[],
    _selectedOrderIds: Array<string>,
  ): Array<BfxBlotterAction> {
    const enabledItems = [BfxBlotterAction.ACTION_SPOT_RISK_EXPORT_TO_CSV];
    return enabledItems;
  }

  protected prepareActions(_ladderBlotter: any): void {}

  public getMenuItems(): Array<BmarkFwdRiskContextMenuItem> {
    let ret: Array<BmarkFwdRiskContextMenuItem> = this.menuItems;

    return ret;
  }

  public buildMenu(
    blotter: BfxBaseBlotter,
    pageX: number,
    pageY: number,
    selectedIds: string[],
    selectedItems?: object[],
  ): void {
    let enabledItems: Array<BfxBlotterAction> = this.getEnabledActions(selectedItems, selectedIds);
    this.showMenuAt(blotter, pageX, pageY, enabledItems, []);
  }

  protected initMenuItems(): void {
    this.menuItems = [];

    let exportMenuItem: BmarkFwdRiskContextMenuItem = new BmarkFwdRiskContextMenuItem(
      BfxBlotterAction.ACTION_SPOT_RISK_EXPORT_TO_CSV,
      "Export to CSV",
      " ",
      "",
    );
    this.menuItems.push(exportMenuItem);
  }

  protected exportToCSV(event: BfxBlotterActionEvent) {
    logger.out.info(
      `${this.constructor.name}: Exporting ${event.selectedItems.length} pairs to CSV.`,
    );

    const tenorAdapter = new TenorAdapter();

    const exportRows = [];
    const pairModels = event.selectedItems as BmarkFwdRiskDisplayModel[];
    for (const pairData of pairModels) {
      let pair: string = pairData.ccyPair;
      let ccy: string = pairData.baseCcy;
      let op: string;
      if (pairData.getTenor() === CubiqTS.Tenor.SPOT) {
        op = pairData.totalInternal.lte(0) ? "BUY" : "SELL";
      } else {
        op = pairData.totalInternal.gte(0) ? "BUY" : "SELL";
      }

      let valueDateStr: string;
      if (pairData.getTenor() === CubiqTS.Tenor.SPOT) {
        valueDateStr = "";
      } else {
        const valueDate = pairData.getValueDate();
        valueDateStr = valueDate?.clone().utc().format("DD-MMM-YY") ?? "<UNKNOWN>";
      }

      let amt: CubiqTS.BigNumber = pairData.totalInternal.abs();
      const tenor: CubiqTS.Tenor = pairData.getTenor();
      const tenorName: string = tenor == null ? "BRK" : tenorAdapter.getTenorStr(tenor);
      let row: string[] = [pair, op, ccy, amt.toString(), valueDateStr, tenorName];
      exportRows.push(row);
    }

    const headers: string[] = ["CcyPair", "Dir", "Ccy", "Total (Internal)", "Value Date", "Tenor"];
    const payload = {
      title_text: "Export Benchmark Forward Risk as CSV",
      message_text: "Do you want to export data for all forward positions?",
      headers: headers,
      rows: exportRows,
      export_input_type: EXPORT_INPUT_TYPE.ARRAY_DATA,
      export_output_type: EXPORT_OUTPUT_TYPE.CSV_EXPORT,
      // ladderBlotter,
      blotterName: "benchmark_spot_risk",
    };

    this.fwdRiskDialogSubject.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN, null, null, payload),
    );
  }
}

export class BmarkFwdRiskContextMenuItem extends BfxBlotterContextMenuItem<any> {
  constructor(
    public actionId: BfxBlotterAction,
    title: string = "",
    public iconClass: string = " ",
    public iconClassRight?: string,
  ) {
    super(
      actionId,
      title,
      () => {
        return;
      },
      () => {
        return;
      },
    );
    this.state.available = true;
  }
}
